import script from "./CancelEventDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelEventDialog.vue?vue&type=script&setup=true&lang=js"

import "./CancelEventDialog.vue?vue&type=style&index=0&id=12b5c464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b5c464"]])

export default __exports__